import { render, staticRenderFns } from "./RequestServiceStatusHistory.vue?vue&type=template&id=c8e60850&scoped=true"
import script from "./RequestServiceStatusHistory.vue?vue&type=script&lang=js"
export * from "./RequestServiceStatusHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceStatusHistory.vue?vue&type=style&index=0&id=c8e60850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e60850",
  null
  
)

export default component.exports